import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import ReduxLogger from "redux-logger";

import rootReducers from '../reducers/rootReducers';
import { getSessionStorage, updateSessionStorage } from '../../utils/helperServices';
import { EnvConfig } from "../../config";

export default initialState => {

    function saveToSessionStorage(state) {
      try {
        //code need to be updated
        if (typeof window !== 'undefined') {
          // code need to be updated
          updateSessionStorage('state', state);
        }
      } catch(e) {
        console.log(e);
      }
    }

    function loadFromSessionStorage() {
      try {
        if (typeof window !== 'undefined') {
          const serializedState = getSessionStorage('state');
          if(serializedState === null) return undefined;

          return serializedState;
        }
      } catch(e) {
        console.log(e);
        return undefined;
      }
    }

    const persistedState = typeof window !== "undefined" ? loadFromSessionStorage() : initialState;
    const isProdEnv = process.env.NODE_ENV === "production";

    const middleware = [
      thunk,
    ];

    if (!isProdEnv && EnvConfig?.redux?.enableLogger) {
      middleware.push(ReduxLogger);
    }

    const store = createStore(
      rootReducers,
      persistedState,
      applyMiddleware(...middleware)
    )

    // IF REDUCERS WERE CHANGED, RELOAD WITH INITIAL STATE
    if (module.hot) {
      module.hot.accept('../reducers/rootReducers', () => {
        const createNextReducer = require('../reducers/rootReducers').default
        store.replaceReducer(createNextReducer(initialState))
      })
    }

    store.subscribe(() => {
      saveToSessionStorage(store.getState());
    })

    return { store };
  }
